/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { Grid, Button } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles = theme => ({
    root: {
        background: theme.headerBackground ? theme.headerBackground : '#ffffff',
        boxShadow: theme.headerBoxShadow ? theme.headerBoxShadow : '0 1px 10px rgba(0, 0, 0, 0.15)',
        marginBottom: theme.spacing(4),
        borderBottom: '10px solid ' + theme.palette.primaryColor,
        [theme.breakpoints.down(600)]: {
            marginBottom: theme.spacing(2)
        }
    },
    container: {
        maxWidth: 960,
        margin: 'auto',
        padding: theme.spacing(1.25) + 'px ' + theme.spacing(3) + 'px ' + theme.spacing(2) + 'px ' + theme.spacing(2.5) + 'px'
    },
    logo: {
        width: theme.logoWidth,
        height: 30,
        float: 'left',
        background: 'url(' + theme.logo + ')',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        marginTop: 3
    },
    grid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    cirles: {
        display: 'flex',
        flexDirection: 'row'
    },
    primaryThemeColorCircle: {
        width: 15,
        height: 15,
        background: theme.palette.primaryColor,
        margin: '0 0 0 12px',
        borderRadius: 12
    },
    secondaryThemeColorCircle: {
        width: 15,
        height: 15,
        background: theme.palette.secondaryColor,
        margin: '0 0 0 12px',
        borderRadius: 12
    },
    menuWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 5
    },
    menuItem: {
        fontWeight: 500,
        padding: theme.spacing(0, 2)
    },
    link: {
        textDecoration: 'none'
    },
    isNotMobile: {
        display: 'flex',
        [theme.breakpoints.down(600)]: {
            display: 'none'
        }
    },
    isMobile: {
        display: 'none',
        [theme.breakpoints.down(600)]: {
            display: 'flex'
        }
    },
    menuButtonWrapper: {},
    menuButton: {
        padding: 0,
        minWidth: 0
    },
    menuIcon: {},
    mobileMenu: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        zIndex: 1,
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(0.5),
        [theme.breakpoints.up(600)]: {
            display: 'none'
        },
        [theme.breakpoints.down(400)]: {
            boxShadow: '0 5px 10px rgba(0,0,0,0.2)'
        }
    },
    mobileMenuWrapper: {
        [theme.breakpoints.down(400)]: {
            flexDirection: 'column',
            gap: 8
        }
    }
})

const menuItems = [
    {
        label: 'Etusivu',
        url: ''
    },
    {
        label: 'Tutkimukset',
        url: '&ca=tutkimukset'
    },
    {
        label: 'Teetä oma tutkimus',
        url: '&ca=teeta-oma-tutkimus'
    }
]

class PageHeader extends PureComponent {
    state = {
        isMenuOpen: false
    }

    handleToggleMenu = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen })
    }

    render() {
        const { classes, baseUrl } = this.props
        const { isMenuOpen } = this.state

        return (
            <div className={classes.root + ' page-header'}>
                <Grid container className={classes.container}>
                    <Grid item xs={12} className={classes.grid}>
                        <a href={baseUrl}><div className={classes.logo + ' page-logo'}></div></a>
                        <div className={classes.menuWrapper + ' ' + classes.isNotMobile}>
                            {menuItems.map((menuItem, key) => (
                                <a href={baseUrl + menuItem.url} className={classes.link}>
                                    <div className={classes.menuItem}>{menuItem.label}</div>
                                </a>
                            ))}
                        </div>
                        <div style={{ flexGrow: 1 }}></div>
                        <div className={classes.cirles + ' ' + classes.isNotMobile}>
                            <div className={classes.primaryThemeColorCircle}></div>
                            <div className={classes.secondaryThemeColorCircle}></div>
                        </div>
                        {isMenuOpen && (
                            <div className={classes.mobileMenu + ' ' + classes.isMobile}>
                                <Button
                                    color="primary"
                                    size="large"
                                    className={classes.menuButton}
                                    onClick={this.handleToggleMenu}
                                    style={{ margin: '12px 16px 0 auto' }}
                                >
                                    <FontAwesomeIcon className={classes.menuIcon} size="lg" icon={['far', 'times']} />
                                </Button>
                                <div className={classes.menuWrapper + ' ' + classes.mobileMenuWrapper}>
                                    {menuItems.map((menuItem, key) => (
                                        <a href={baseUrl + menuItem.url} className={classes.link}>
                                            <div className={classes.menuItem}>{menuItem.label}</div>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className={classes.menuButtonWrapper + ' ' + classes.isMobile}>
                            <Button color="primary" size="large" className={classes.menuButton} onClick={this.handleToggleMenu}>
                                <FontAwesomeIcon className={classes.menuIcon} size="lg" icon={['far', 'bars']} />
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(PageHeader)
